rawFlags